const WordIcon = () => {
    return (
        <i className="fa fa-file-word" style={{ fontSize: 16, color: "#2563eb" }} />
    )
}

export default WordIcon;